import { jsPDF } from 'jspdf';

export function saveGraphPdf({
	imageData, width, height, filename = 'graph',
}) {
	const pdfDoc = new jsPDF('p', 'mm', 'a4');
	const scale = pdfDoc.internal.pageSize.getWidth() / width;

	pdfDoc.addImage(imageData, 'JPEG', 0, 0, width * scale, height * scale);
	pdfDoc.save(`${filename}.pdf`);
}
